/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function BirthPlaceField (props: FormTextFieldProps) {
  const { name = 'birthPlace', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'birth_place',
        defaultMessage: 'Lieu de naissance'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default BirthPlaceField
